import Api from '@/api';

const state = {
    loaded: false,
    loading: false,
    articles: []
};

const mutations = {
    SET_ARTICLES(state, articles) {
        state.articles = articles
    },
    SET_LOADING(state, loading) {
        state.loading = loading
    },
    SET_LOADED(state, loaded) {
        state.loaded = loaded
    },
};

const getters = {
    ARTICLES(state) {
        return state.articles;
    },
    LOADED(state) {
        return state.loaded;
    },
    LOADING(state) {
        return state.loading;
    },
};

const actions = {
    async FETCH_ARTICLES(context) {

        context.commit('SET_LOADED', false)
        context.commit('SET_LOADING', true);

        const response = await Api.get('/cms/categories');

        context.commit('SET_ARTICLES', response.data.CmsCategories[0].Articles);
        context.commit('SET_LOADED', true)
        context.commit('SET_LOADING', false)

    },
    SET_ARTICLES({ commit }, articles) {
        commit('SET_ARTICLES', articles);
    },
    SET_LOADING({ commit }, loading) {
        commit('SET_LOADING', loading);
    },
    SET_LOADED({ commit }, loaded) {
        commit('SET_LOADED', loaded);
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
